import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "./locales/en.json";
import translationVi from "./locales/vi.json";
import enFlag from '../src/assets/flags/us.jpg';
import vietnameseFlag from '../src/assets/flags/vietnam.jpg';
export const languages = [
  {
    key: 'EN',
    name: 'English',
    flag: enFlag,
  },
  {
    key: 'VI',
    name: 'Vietnamese',
    flag: vietnameseFlag,
  },
];
const resources = {
  vi: {
    translation: translationVi,
  },
  en: {
    translation: translationEn,
  },
};


const savedLanguage = localStorage.getItem("i18nextLng") || "vi";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "vi",
    interpolation: {
      escapeValue: false, 
    },
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18n;